// @ts-ignore
const { Chatroom, WebRTC2 } = window;

export { Chatroom, WebRTC2 };

// 监听云信事件并上传
// 参考 https://dev.yunxin.163.com/docs/interface/NERTC_SDK/Latest/Web/api/interfaces/client.client-1.html#on
export const debugerNIMEventList = [
  'notFound',
  'deviceError',
  'beOccupied',
  'accessDenied',
  'connection-state-change',
  'error',
  'warning',
  'audioTrackEnded',
  'videoTrackEnded',
  'rtmp-state',
  // 'network-quality',
  'exception',
  'crypt-error',
];
